module.exports = __webpack_public_path__ + "static/Jordan-b347c2bec64f49bbee012aed2784e7e1.png";